import script from "./Balance.vue?vue&type=script&setup=true&lang=js"
export * from "./Balance.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/Balance.css?vue&type=style&index=0&id=7a4ee7ef&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4ee7ef"]])

export default __exports__